// removed by extract-text-webpack-plugin
module.exports = {"component":"Footer__component___12N_g","wrapper":"Footer__wrapper___6FB8d","title":"Footer__title___1-ue9","text":"Footer__text___uTo_O","graytext":"Footer__graytext___3CF73","phone":"Footer__phone___14WE5","line":"Footer__line___Vwyjm"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Footer.css
// module id = 402
// module chunks = 0